import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eFoCaAnTruongActionTypeIds, IFoCaAnTruongActionTypes } from "../../action-types/dich-vu/IFoCaAnTruongActionTypes";
import { IFoCaAnTruongPageStateModel } from "../../page-state-model/dich-vu/IFoCaAnTruongPageState";

const initialState: IFoCaAnTruongPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	fo_caan_truongs: [],
	fo_caans: [],
	fo_caan_truong_editing: undefined,
	fo_caan_truong_selected_ids: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false
}

export const foCaAnTruongReducer = (state: IFoCaAnTruongPageStateModel = initialState, action: IFoCaAnTruongActionTypes): IFoCaAnTruongPageStateModel => {
	switch (action.type) {
		case eFoCaAnTruongActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eFoCaAnTruongActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				fo_caan_truongs: action.payload
			}
		case eFoCaAnTruongActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				fo_caan_truongs: []
			}
		case eFoCaAnTruongActionTypeIds.LOAD_CAAN_START:
			return {
				...state
			}
		case eFoCaAnTruongActionTypeIds.LOAD_CAAN_SUCCESS:
			return {
				...state,
				fo_caans: action.payload
			}
		case eFoCaAnTruongActionTypeIds.LOAD_CAAN_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				fo_caans: []
			}
		case eFoCaAnTruongActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				fo_caan_truong_editing: action.payload
			}
		case eFoCaAnTruongActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				fo_caan_truong_editing: undefined
			}
		case eFoCaAnTruongActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				fo_caan_truong_selected_ids: action.payload
			}
		case eFoCaAnTruongActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eFoCaAnTruongActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eFoCaAnTruongActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eFoCaAnTruongActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm mới thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				fo_caan_truong_editing: undefined
			}
		case eFoCaAnTruongActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eFoCaAnTruongActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eFoCaAnTruongActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xóa thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				fo_caan_truong_editing: undefined,
				fo_caan_truong_selected_ids: []
			}
		case eFoCaAnTruongActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		default:
			return state;
	}
}
